<div class="multiple-select-dropdown" [ngClass]="uniqueClassName" (keydown)="keyDown($event)" (clickOutside)="hideDropDown()">
  <span class="multiple-select-dropdown-name input-name" >{{ name }}</span>
  <div [class.multiple-select-dropdown-focused]="focused">
    <ng-multiselect-dropdown [ngClass]="{ 'multiple-select-dropdown': !recommended, 'multiple-select-dropdown-yellow': recommended }" [placeholder]="placeholder" [settings]="dropdownSettings"
      [data]="dropdownList" [(ngModel)]="selectedItems" (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
    </ng-multiselect-dropdown>
  </div>
  <div tabindex="0" class="tab-stop" (focus)="setFocus()" (blur)="setBlur()"></div>
</div>
